import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KbFilterPipe } from './filter.pipe';
import { TranslateAndFormatPipe } from './KbTranslate.pipe';
import { UnselectPipe } from './unselect.pipe';
import { updateValuePipe } from './valueBinder.pipe';
import { HighlightSearchPipe } from './highlightSearch.pipe';
import { NewlineToBrPipe } from './newLine.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [KbFilterPipe, TranslateAndFormatPipe, UnselectPipe, updateValuePipe,HighlightSearchPipe,NewlineToBrPipe],
  exports: [KbFilterPipe, TranslateAndFormatPipe, UnselectPipe, updateValuePipe,HighlightSearchPipe,NewlineToBrPipe],
})
export class KbPipesModule { }
